import React from "react";

/**
 * Quick Tips Modal - Shows on first location to explain how to play
 * Focuses on explaining the tabs and core gameplay mechanics
 */
export function MissionQuickTips({ onClose, tour }) {
  // Dynamic values from tour data
  const locationCount = tour?.steps?.length || 10;
  const timeLimit = tour?.suggestedTimeLimit || 120;
  const timeDisplay = timeLimit >= 60 ? `${timeLimit / 60} hour${timeLimit > 60 ? 's' : ''}` : `${timeLimit} minutes`;
  const handleClose = () => {
    onClose();
  };

  return (
    <div
      className="fixed z-50 overflow-y-auto"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(12px)',
        padding: 'calc(env(safe-area-inset-top, 0px) + 1rem) 1rem calc(env(safe-area-inset-bottom, 0px) + 1rem)'
      }}
    >
      <div className="min-h-full flex items-center justify-center">
        <div
          className="w-full max-w-lg rounded-xl overflow-hidden"
          style={{
            background: '#1e293b',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            boxShadow: '0 0 40px rgba(16, 185, 129, 0.2)'
          }}
        >
          <div className="p-6">
          {/* Header */}
          <h2
            className="text-center font-mono text-2xl font-bold mb-6 tracking-wider"
            style={{ color: '#10B981' }}
          >
            MISSION QUICK TIPS
          </h2>

          {/* Tips Content */}
          <div className="mb-6">
            {/* Combined Goal and Instructions */}
            <div
              className="p-4 rounded-lg"
              style={{
                background: 'rgba(16, 185, 129, 0.05)',
                border: '1px solid rgba(16, 185, 129, 0.2)'
              }}
            >
              <div className="font-semibold text-emerald-400 text-lg mb-2">Your Goal</div>
              <div className="text-base text-gray-300 leading-relaxed">
                Visit {locationCount} locations and solve the riddle at each. You have {timeDisplay}.
              </div>

              <div style={{ height: '1px', background: 'rgba(16, 185, 129, 0.2)', margin: '1rem 0' }} />

              <div className="text-base text-gray-300 leading-relaxed mb-3">
                At each location, you will see the following tabs:
              </div>

              <div className="space-y-3 text-base text-gray-300">
                <div>
                  <div className="font-mono font-bold text-emerald-400 mb-1">Directions</div>
                  <div>Directions and map to location</div>
                </div>
                <div>
                  <div className="font-mono font-bold text-emerald-400 mb-1">Intel</div>
                  <div>Historical context about the location</div>
                </div>
                <div>
                  <div className="font-mono font-bold text-emerald-400 mb-1">Cipher</div>
                  <div>The riddle you need to solve to move forward</div>
                </div>
              </div>
            </div>
          </div>

          {/* Got It button */}
          <button
            onClick={handleClose}
            className="w-full py-3 rounded-lg font-semibold text-sm uppercase tracking-wide"
            style={{
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: '#ffffff',
              border: 'none',
              cursor: 'pointer',
              boxShadow: '0 0 20px rgba(16, 185, 129, 0.3)'
            }}
          >
            Let's Go
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
